export default __webpack_public_path__ + "static/media/help.6733c9bd.png";